import React, { createContext, useContext, useState } from 'react';

const ViewAsContext = createContext();

export const useViewAs = () => {
  const context = useContext(ViewAsContext);
  if (!context) {
    throw new Error('useViewAs must be used within ViewAsProvider');
  }
  return context;
};

export const ViewAsProvider = ({ children }) => {
  const [viewAsRole, setViewAsRole] = useState(null); // null means use actual user role

  const setViewRole = (role) => {
    setViewAsRole(role);
  };

  const clearViewRole = () => {
    setViewAsRole(null);
  };

  const getEffectiveRole = (actualRole) => {
    return viewAsRole || actualRole;
  };

  return (
    <ViewAsContext.Provider value={{ viewAsRole, setViewRole, clearViewRole, getEffectiveRole }}>
      {children}
    </ViewAsContext.Provider>
  );
};
